/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchChangeProposalsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {SearchChangeProposalsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const searchChangeProposals = (request: SearchChangeProposalsRequest, options?: CashRequestOptions) => post<SearchChangeProposalsRequest, SearchChangeProposalsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/SearchChangeProposals", request, {...options, rejectOnError: true })